import { Check } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ITENS_DO_TOUR, useGuidedTourStore } from '@/stores/guidedTourStore'
import type { ItemDoTour } from '@/stores/guidedTourStore'

/** Aba Primeiros passos: checklist das funções do tour, com progresso "N de 4". */
export function AjudaPassos() {
  const { t } = useTranslation()
  const feitos = useGuidedTourStore((s) => s.feitos)
  const total = ITENS_DO_TOUR.length
  const vistos = ITENS_DO_TOUR.filter((i) => feitos[i]).length

  function mostrar(item: ItemDoTour) {
    const { fecharAjuda, pedirItem } = useGuidedTourStore.getState()
    fecharAjuda()
    pedirItem(item)
  }

  function refazer() {
    const { fecharAjuda, pedirInicio } = useGuidedTourStore.getState()
    fecharAjuda()
    pedirInicio()
  }

  return (
    <div>
      <p className="axg-ajuda-texto">{t('guidedTour.ajuda.passos.intro')}</p>
      <p className="axg-ajuda-item-titulo" data-testid="ajuda-progresso-texto">
        {t('guidedTour.botoes.progresso', { current: vistos, total })}
      </p>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={vistos}
        aria-label={t('guidedTour.ajuda.passos.progressoRotulo')}
        data-testid="ajuda-progresso"
        className="axg-ajuda-barra"
      >
        <div className="axg-ajuda-barra-cheia" style={{ width: `${(vistos / total) * 100}%` }} />
      </div>
      <ul className="axg-ajuda-lista">
        {ITENS_DO_TOUR.map((item) => {
          const feito = feitos[item] === true
          return (
            <li key={item} className="axg-ajuda-cartao" data-testid={`ajuda-item-${item}`} data-feito={feito}>
              <span
                className="axg-ajuda-marca"
                data-feito={feito}
                role="img"
                aria-label={t(feito ? 'guidedTour.ajuda.passos.feito' : 'guidedTour.ajuda.passos.pendente')}
              >
                {feito ? <Check size={14} aria-hidden="true" /> : null}
              </span>
              <div className="axg-ajuda-corpo">
                <p className="axg-ajuda-item-titulo">{t(`guidedTour.ajuda.itens.${item}.titulo`)}</p>
                <p className="axg-ajuda-texto">{t(`guidedTour.ajuda.itens.${item}.texto`)}</p>
              </div>
              <button type="button" className="axg-ajuda-botao" onClick={() => mostrar(item)}>
                {t(feito ? 'guidedTour.ajuda.passos.rever' : 'guidedTour.ajuda.passos.mostrar')}
              </button>
            </li>
          )
        })}
      </ul>
      <button type="button" className="axg-ajuda-botao axg-ajuda-botao-largo" onClick={refazer}>
        {t('guidedTour.ajuda.passos.refazer')}
      </button>
      <p className="axg-ajuda-texto">{t('guidedTour.ajuda.passos.refazerDica')}</p>
    </div>
  )
}
